const StudentAdmission = () => {
    return (
        <div className="bg-gray-100">
            <div className="px-4 bg-gray-100">


                <div className="mt-8 ">
                    <h1 className="text-xl">Students</h1>
                    <span className="flex space-x-2 mt-2">
                        <h2>Home &gt;</h2>
                        <h2 className="text-yellow-500">Student Admit Form</h2>
                    </span>
                </div>


                <div className="bg-white mt-4 md:mx-12">
                    <span className="flex justify-between space-y-4 place-items-center mt-8 mb-4 px-8">
                        <h2 className="text-xl font-semibold">Add New Students</h2>
                        <h2>...</h2>
                    </span>

                    <form className="grid grid-cols-1 md:grid-cols-2  md:gap-4 bg-white px-4  space-y-8 text-gray-700">

                        <span className="flex flex-col space-y-2">
                            <label htmlFor="text">First Name</label>
                            <input type="text" className="md:py-4 py-2 outline-none block bg-gray-200 md:px-2 px-2" />
                        </span>
                        <span className="flex flex-col space-y-2">
                            <label htmlFor="text">Last Name</label>
                            <input type="text" className="md:py-4 py-2 outline-none block bg-gray-200 md:px-2 px-2" />
                        </span>

                        <span className="flex flex-col space-y-2">
                            <label for="gender" class="block text-gray-700">Gender</label>
                            <select class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                                <option value="FR">Female</option>
                                <option value="DE">Male</option>
                            </select>
                        </span>

                        <span className="flex flex-col space-y-2">
                            <label htmlFor="DOB">Date Of Birth</label>
                            <input type="text" placeholder="dd/mm/yy" className="md:py-4 py-2 outline-none block bg-gray-200 md:px-2 px-2" />
                        </span>

                        <span className="flex flex-col space-y-2">
                            <label htmlFor="Roll">Roll</label>
                            <input type="text" className="md:py-4 py-2 outline-none block bg-gray-200 md:px-2 px-2" />
                        </span>

                        <span className="flex flex-col space-y-2">
                            <label htmlFor="BG">Blood Group</label>
                            <select class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                                <option >A+</option>
                                <option>A-</option>
                                <option >B+</option>
                                <option >B-</option>
                                <option >O+</option>
                                <option >O-</option>
                            </select>
                        </span>

                        <span className="flex flex-col space-y-4">
                            <label htmlFor="Religion">Religion</label>
                            <select class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                                <option >Christian</option>
                                <option>Islam</option>
                                <option >Buddish</option>
                                <option >Hindu</option>
                            </select>
                        </span>

                        <span className="flex flex-col space-y-4">
                            <label htmlFor="Email">Email</label>
                            <input type="email" className="md:py-4 py-2 outline-none block bg-gray-200 md:px-2 px-2" />
                        </span>

                        <span className="flex flex-col space-y-4">
                            <label htmlFor="Class">Class</label>
                            <select id="countries" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                                <option >Play</option>
                                <option>Nursary</option>
                                <option>1</option>
                                <option>2</option>
                                <option>3</option>
                                <option>4</option>
                            </select>
                        </span>

                        <span className="flex flex-col space-y-4">
                            <label htmlFor="AID">Admission ID</label>
                            <input type="text" className="md:py-4 py-2 outline-none block bg-gray-200 md:px-2 px-2" />
                        </span>

                        <span className="flex flex-col space-y-4">
                            <label htmlFor="Phone">Phone</label>
                            <input type="tel" className="md:py-4 py-2 outline-none block bg-gray-200 md:px-2 px-2" />
                        </span>
                        <span>
                            <label htmlFor="Bio">Bio</label>
                            <textarea class="block w-full bg-gray-200 border border-gray-400 hover:border-gray-500 px-4 py-2 rounded shadow leading-tight focus:outline-none focus:shadow-outline" rows="4"></textarea>
                        </span>



                        <span>
                            <label class="block mb-2 text-sm font-medium text-gray-900 dark:text-white" for="file_input">Upload Student Photo (150px X 150px)</label>
                            <input class="block w-full text-sm text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-200 dark:text-gray-400 focus:outline-none dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400" aria-describedby="file_input_help" id="file_input" type="file" />
                        </span>

                    </form>

                    <div className="flex space-x-8 mt-12 px-4 justify-center pb-24">
                        <button className="bg-yellow-500 text-white  px-8 py-2 rounded-lg">Save</button>
                        <button className="bg-blue-700 text-white px-8 py-2 rounded-xl">Reset</button>
                    </div>
                </div>
            </div>


        </div>
    );
}

export default StudentAdmission;